import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import {
  BasicSelect
} from 'vue-search-select';
export default {
  name: 'Scantallybatchclosure',
  components: {
      VueElementLoading,
      Paginate,
      BasicSelect,
      Multiselect,
  },
  mixins:[PageTracker],
  data: function() {
      return {
        hubList : [],
        batchData : [],
        tableLoading: false,
        allhublist:[],
        userDataKey : '',
        hubID:[],
        status:'',
        comment:'',
        tableflag: false,
        Loading: false,
        onSubmit:false,
        userDataKey: ''
      }
  },
  created: function() {

  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail.userid
    this.username = userdetail.username
    let getHubList = localStorage.getItem('allhubaccesslist');
    var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
    var hubList = byteHub.toString(CryptoJS.enc.Utf8);
    this.allhublist = JSON.parse(hubList);
    // this.hubID = userdetail.hubdetails[0]
    //this.getHubzoneIDByHubID(this.hubID);
    // this.getUserHubZoneDetails = await this.getHubDetailsbyID(this.userid,this.hubID);

  },
  methods : {

    validateForm(scope) {
      this.onSubmit=true;
      this.$validator.validateAll(scope).then(result => {
        if(result) {
          this.saveScantallybatchclosure()
          // this.openModel()
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },



    clear(){
      this.onSubmit=false;
     this.$validator.reset();
      this.errors.clear();
      this.hubID = '';
      this.comment= '';
      this.status='';
      this.batchData=[]
      this.tableflag=false;
    },
    saveScantallybatchclosure(){
        console.log(this.hubID, this.status, this.comment)
            if(this.hubID.length==0){
                this.$alertify.error("Please select Hub.")
                return
              }
              if(this.comment===null || this.comment==='' ){
                  this.$alertify.error("Comment must be required")
              }
              if(this.comment.length>=190){
                this.$alertify.error("Comment must be less than 190 characters")
                return
              }
              if(this.status===""){
                  this.$alertify.error("Please select status")
                  return
              }
              let fetchHubName=this.hubID.map(item => item.HubName).join(', ');
        let message = {
          title: '',
          body: ` <div class="row">
                <div class="col-md-12">
                  <b style="font-size: 20px;">Do you want to closed batch for below Hubs :</b>
                </div>
                <div class="col-md-12">
                  <p>${fetchHubName}</p>
                </div>

              </div>`,
        }
        this.$dialog.confirm(message, {
          html: true,
          animation: 'bounce',
          backdropClose: true,
          okText: 'Yes',
          cancelText: 'No',
          reverse: true
          //loader: true
        })
        .then(dialog => {
          this.confirmedSave();
        })
        .catch(() => {
          console.log('cancelled Request.!');
        })
        // this.modelValue=false;

    },

    async confirmedSave(){
       this.tableflag = true
       this.Loading =false
        let hubIDarray = []
        if(this.hubID.length > 0 ){
          this.hubID.map(hub=>{
            hubIDarray.push(hub.HubID)
          })
        }
          let data = {
                 hubid : hubIDarray,
                 comments :  this.comment,
                 batchstatus : this.status,
                 scantallyat: "servicecenter",
                 batchtype:"ScanTally",
                 lastmodifiedby: this.username
         };
               await axios.post(apiUrl.api_url_for_scantally+ 'shipmentscantally/new/supportdesk/closebatch/byhubid',data)
                 .then( (response) => {
                   this.Loading = false
                     if(response.data.code == 200){
                         if(response.data.data.length > 0){
                           let resData=response.data.data;
                           let mergedArray = resData.map(obj1 => {
                                 let obj2 = this.allhublist.find(obj => obj.HubID === obj1.hubid);
                                 return Object.assign({}, obj1, obj2);
                             });

                             this.batchData=mergedArray;
                             this.Loading = false;
                             this.$alertify.success("Request processed successfully, Please check batch closure status in the below table.");
                            //    let totalRows = response.data.data.length;
                            //    this.totalRecords = totalRows
                            //    if (totalRows < 100) {
                            //        this.pagecount = 1;
                            //    } else {
                            //        this.pagecount = Math.ceil(totalRows / 100)
                            //    }

                         }else {
                             this.$alertify.error("No Records to Show!!!!!");
                         }
                     }
                     else {
                         this.$alertify.error(response.data.message);
                     }
                 })
                 .catch((httpException) => {
                       this.tableLoading = false
                       this.$alertify.error("Something went to wrong");
                       console.error('exception is:::::::::', httpException)
                 })
    },
    // openModel(){
    //   // if(this.hubID.length==0){
    //   //   this.$alertify.error("Please select Hub.")
    //   // }
    //   // if(this.comment===null || this.comment===''){
    //   //     this.$alertify.error("Comment must be required")
    //   // }
    //   // if(this.status==="*"){
    //   //     this.$alertify.error("Please select status")
    //   // }
    //   if(this.hubID.length!=0 &&
    //     (this.comment!=null || this.comment!='') &&
    //     this.status!="*"
    //   ){
    //     this.modelValue=true;
    //   }else{
    //     this.$alertify.error("Please fill all the fields")
    //   }
    // },
    // closeResultModel() {
    //   this.modelValue =false
    // },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/Scantallybatchclosure/Scantallybatchclosure.component.js